import { render, staticRenderFns } from "./Ep2.vue?vue&type=template&id=06dabeb7&scoped=true&"
import script from "./Ep2.vue?vue&type=script&lang=ts&"
export * from "./Ep2.vue?vue&type=script&lang=ts&"
import style0 from "./Ep2.vue?vue&type=style&index=0&id=06dabeb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dabeb7",
  null
  
)

export default component.exports